import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    padding: [theme.spacing(3), 0],
    [theme.breakpoints.up('mobile')]: {
      padding: [theme.spacing(4), 0],
    },
  },
  field: {
    width: '100%',
    marginBottom: theme.spacing(3),
    '& fieldset': {
      borderColor: theme.palette.colors.border,
    },
    '& label': {
      position: 'relative',
      transform: 'none',
      fontSize: 12,
      marginBottom: theme.spacing(1),
      color: '#90A4AE',
    },
    '& input': {
      height: '100%',
      padding: [0, 14],
    },
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(2),
    },
  },
  subTitle: {
    marginBottom: theme.spacing(2),
  },
}));



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentSettingsPage/components/ProfileForm/useStyles.js